import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";

export const LegalLayout = ({ title, updated, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#FFFFFF] min-h-screen">
      <Header />
      <main className="pt-32 lg:pt-40 pb-20 lg:pb-28">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          <Link
            to="/"
            className="inline-flex items-center gap-2 font-body text-sm font-medium text-[#6B6B66] hover:text-[#F8B808] transition-colors mb-8"
          >
            <ArrowLeft className="h-4 w-4" /> Back to home
          </Link>
          <h1 className="font-heading text-4xl sm:text-5xl font-medium tracking-tight text-[#1A1A1A] leading-[1.04]">
            {title}
          </h1>
          <p className="font-body text-sm text-[#9A958C] mt-4">Last updated: {updated}</p>
          <div className="mt-10 space-y-[35px] lg:space-y-9">{children}</div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export const LegalSection = ({ heading, children }) => (
  <section>
    <h2 className="font-heading text-xl font-semibold text-[#1A1A1A] mb-3">{heading}</h2>
    <div className="space-y-3 font-body text-base text-[#6B6B66] leading-relaxed">
      {children}
    </div>
  </section>
);
